import React from 'react'

import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Header, Button } from 'semantic-ui-react'

import SubSection from '../../../components/common/SubSection'
import Title from '../../../components/common/Title'

const ClaimTab = ({ history, match, projectTitle, exitProject }: IProps) => {
  return (
    <>
      <Title title={projectTitle}>
        <>
          <Button compact onClick={exitProject}>
            Close
          </Button>
        </>
      </Title>

      <SubSection hasGreyBackground>
        <>
          <Header as="h1" style={{ marginBottom: '2rem', fontWeight: 'bold' }}>
            Consent Report
            <Header.Subheader>
              Some description text here.
            </Header.Subheader>
          </Header>
        </>
      </SubSection>
    </>
  )
}

interface IProps extends RouteComponentProps<any> {
  projectTitle: string
  exitProject: () => void
}

export default withRouter(ClaimTab)
